export function TicketSystem() {
  return (
    <div className="w-full h-screen overflow-hidden">
      <iframe
        src="/emaildrafter"
        className="w-full h-full border-0"
        title="Mission Solar Ticket System"
      />
    </div>
  )
}